import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import p from "clsx";
import s from "react";

var m = function m(_ref) {
  var a = _ref.className,
      n = _ref.isCta,
      c = _ref.children,
      o = _ref.openInNewTab,
      t = _objectWithoutProperties(_ref, ["className", "isCta", "children", "openInNewTab"]);

  var r;
  var e = t.href ? "a" : "button";
  return s.createElement(e, _objectSpread(_objectSpread({
    type: e === "button" ? (r = t.type) != null ? r : "button" : void 0,
    target: e === "a" && o ? "_blank" : void 0,
    rel: e === "a" && o ? "noopener noreferrer" : void 0
  }, t), {}, {
    className: p({
      "hg-secondarynav__button": n,
      "hg-secondarynav__link": !n
    }, a)
  }), c);
};

export { m as SecondaryNavItem };